import type { R2BStagingBrandEntity } from "../../entity_types/r2bStagingBrand";

export const r2b_staging_like_family: R2BStagingBrandEntity = {
  token: "r2b_staging_like-family",
  type: "r2bStagingBrand",
  name: "Like Family",
  avatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/72a0246dfb2c7f5c103865975dd69579da0b926ff012ccfee29299cd3ec17d67.webp",
  productImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/72a0246dfb2c7f5c103865975dd69579da0b926ff012ccfee29299cd3ec17d67.webp",
    "https://cdn.prerelease.faire.dev/fastly/bab024d6c8bdf44adf9cde8a8fdf3bf5ef087386c597c6666bfe3771b9a89e72.webp",
    "https://cdn.prerelease.faire.dev/fastly/fd3d710ef1b00e98253d2e76765c2cb111c43daac1870e05e581857ef0c3ccd1.webp",
    "https://cdn.prerelease.faire.dev/fastly/9007fa5f19edc20337cc2b2748b73ad3e9fb59ee1eacb1e6e01022ca23bea977.webp",
    "https://cdn.prerelease.faire.dev/fastly/4a6c774f57af8f42fd41a0e4eba5dcf3d1f60cdc2b777557da6148ddfc5021fe.webp",
    "https://cdn.prerelease.faire.dev/fastly/c27a4d1c220729290822c4da0f11afc7ca89a97f830d7010e62e8fe1c040ed47.webp",
    "https://cdn.prerelease.faire.dev/fastly/8559b426957b1d3db4507700897597c7f509890010a3fbb193970f2af742217a.webp",
    "https://cdn.prerelease.faire.dev/fastly/a46ba3f323057317d15a91722a820ca542cd9eeaea646f5f51fc594546340b9f.webp",
    "https://cdn.prerelease.faire.dev/fastly/1eb26bc40d36e3724628a86b6d1b03b962f0f9a9ac899e09ded6404a13f40385.webp",
    "https://cdn.prerelease.faire.dev/fastly/44e7069cdea416cad77ea239b6deac6b143b727ffd09d957cc28ac4ab3b2c237.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
